import React from 'react';
import { MapPin } from 'lucide-react';
import { getImageUrl } from '../utils/imageUrl';

interface DestinationProps {
  name: string;
  image: string;
  price: number;
  primaryColor: string;
  onDevisClick?: () => void;
}

export default function DestinationCard({ name, image, price, primaryColor, onDevisClick }: DestinationProps) {
  const handleDevisClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onDevisClick) {
      onDevisClick();
    } else {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="group relative overflow-hidden rounded-xl">
      <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300 z-10" />
      
      <img
        src={getImageUrl(image)}
        alt={name}
        className="w-full h-[400px] object-cover transition-transform duration-500 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent z-20">
        <div className="absolute bottom-0 p-6 w-full">
          <div className="flex items-center space-x-2 mb-2">
            <MapPin className="h-5 w-5 text-white" />
            <span className="text-sm text-white">{name}</span>
          </div>
          <div className="flex items-center justify-between w-full">
            <div className="text-white">
              <p className="text-sm text-gray-300">À partir de</p>
              <p className="text-xl font-bold">{price.toLocaleString('fr-DZ')} DA</p>
            </div>
            <div className="ml-auto">
              <a 
                href="#contact"
                onClick={handleDevisClick}
                className="text-white px-6 py-2 rounded-full transition-colors hover:opacity-90 inline-block relative z-30"
                style={{ backgroundColor: primaryColor }}
              >
                Devis
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}